import { motion, AnimatePresence } from "framer-motion";
import { useLocation, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { OwnerSecret } from "./OwnerSecret";
import { CountryPicker } from "./CountryPicker";
import { useCountry } from "../hooks/useCountry";

export const Layout = () => {
    const location = useLocation();
    const { country, ready } = useCountry();
    const [pickerTrigger, setPickerTrigger] = useState("auto");

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [location.pathname]);

    // Listen for global "open country picker" event from Navbar button
    useEffect(() => {
        const handler = () => setPickerTrigger(`manual-${Date.now()}`);
        window.addEventListener("ool:open-country-picker", handler);
        return () => window.removeEventListener("ool:open-country-picker", handler);
    }, []);

    // While country isn't chosen (and we're still loading from storage), keep things visible
    // CountryPicker handles its own auto-open on first visit.

    return (
        <div className="relative min-h-screen flex flex-col">
            <Navbar />
            <AnimatePresence mode="wait">
                <motion.div
                    key={location.pathname}
                    initial={{ opacity: 0, y: 8 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -6 }}
                    transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                    className="flex-1"
                >
                    <Outlet />
                </motion.div>
            </AnimatePresence>
            <Footer />
            <OwnerSecret />
            {/* Show automatic picker on first visit, or manual via Navbar button */}
            {ready && <CountryPicker trigger={country ? pickerTrigger : "auto"} />}
        </div>
    );
};
